var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 13.015L19 13C18.2044 13 17.4413 13.3161 16.8787 13.8787C16.3161 14.4413 16 15.2044 16 16V40C16 41.65 17.35 43 19 43H37C38.65 43 40 41.65 40 40V16C40 14.335 38.65 13.015 37 13.015ZM37 40H19V26.47H37V40ZM37 23.5H19V16H37V23.5ZM22 17.5H25V22H22V17.5ZM22 28H25V35.5H22V28Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.aaf4a816b9ec4143e61c78199342a6b1.svg";
export { ForwardRef as ReactComponent };